"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Solid = exports.HStack = void 0;
const React = require("react");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const standardSizes_1 = require("../../../../types/standardSizes");
const css = (0, cssComposer_1.default)(styles, "HStack");
const HStack = ({ variant = "", size = standardSizes_1.TStandardSizes.Small, children }) => React.createElement("div", { className: css("", `-${variant}`, `-size-${size}`) }, children);
exports.HStack = HStack;
const Solid = ({ children }) => {
    return React.createElement("div", { className: css("solid") }, children);
};
exports.Solid = Solid;
//# sourceMappingURL=index.js.map